import React, { useEffect, useState } from "react";
// import axios from "axios";
import axios from "../context/axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const TourList = () => {
  const [tours, setTours] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");

  // useEffect(() => {
  //   fetchTours();
  // }, [currentPage]);
  useEffect(() => {
    fetchTours();
  }, [currentPage, searchTerm]);

  // const fetchTours = async () => {
  //   try {
  //     const response = await axios.get(`/tours?page=${currentPage}&limit=10`);
  //     setTours(response.data.tours);
  //     setTotalPages(response.data.totalPages);
  //   } catch (error) {
  //     toast.error("Failed to load tours.");
  //   }
  // };
  const fetchTours = async () => {
    try {
      const response = await axios.get(
        `/tours?page=${currentPage}&limit=10&search=${searchTerm}`
      );
      setTours(response.data.tours);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      toast.error("Failed to load tours.");
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`/tours/${id}`);
      setTours((prev) => prev.filter((tour) => tour._id !== id));
      toast.success("Tour deleted successfully!");
    } catch (error) {
      toast.error("Failed to delete tour.");
    }
  };

  return (
    <div className="min-h-screen py-2 px-2">
      {/* <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        draggable
        pauseOnHover
      /> */}
      <div className="max-w-7xl mx-auto p-6  rounded-lg ">
        <h2 className="text-4xl font-extrabold  text-indigo-600 mb-8">
          Tour List
        </h2>

        <div className="mb-4">
  <input
    type="text"
    value={searchTerm}
    onChange={(e) => {
      setSearchTerm(e.target.value);
      setCurrentPage(1);
    }}
    placeholder="Search by tour title..."
    className="px-4 py-2 border border-gray-300 rounded shadow-sm w-full sm:w-1/2"
  />
</div>

        <div className="overflow-x-auto border border-gray-200 rounded-lg">
          <table className="min-w-full text-sm bg-white divide-y divide-gray-200">
            <thead className="bg-indigo-50 text-indigo-600">
              <tr>
                <th className="px-4 py-3 text-center">Sr No.</th>
                <th className="px-6 py-3 text-left">Image</th>
                <th className="px-6 py-3 text-left">Title</th>
                <th className="px-6 py-3 text-left">Price</th>
                <th className="px-6 py-3 text-left">Category</th>
                <th className="px-6 py-3 text-left">State</th>
                <th className="px-6 py-3 text-left">Actions</th>
              </tr>
            </thead>
            <tbody>
              {tours.map((tour, index) => (
                <tr
                  key={tour._id}
                  className="hover:bg-indigo-50 transition-colors"
                >
                  <td className="px-4 py-3 text-center font-medium text-gray-900">
                    {/* {index + 1} */}
                    {(currentPage - 1) * 10 + index + 1}
                  </td>
                  <td className="px-6 py-3">
                    <img
                      src={tour.img}
                      alt={tour.title}
                      className="w-16 h-16 object-cover rounded"
                    />
                  </td>
                  <td className="px-6 py-3 font-medium text-gray-900">
                    {tour.title}
                  </td>
                  <td className="px-6 py-3">${tour.price}</td>
                  <td className="px-6 py-3">{tour.category?.name || "—"}</td>
                  <td className="px-6 py-3">{tour.region?.name || "—"}</td>
                  <td className="px-6 py-3">
                    <button
                      onClick={() => handleDelete(tour._id)}
                      className="text-red-600 hover:text-red-800 font-medium"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="mt-6 flex justify-between items-center">
          <button
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
            className="px-6 py-2 bg-white border border-gray-300 rounded shadow-sm text-gray-700 hover:bg-indigo-100 disabled:opacity-50"
          >
            Previous
          </button>
          <span className="text-gray-700">
            Page <span className="font-semibold">{currentPage}</span> of{" "}
            <span className="font-semibold">{totalPages}</span>
          </span>
          <button
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
            className="px-6 py-2 bg-white border border-gray-300 rounded shadow-sm text-gray-700 hover:bg-indigo-100 disabled:opacity-50"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default TourList;
